import { resolveSiteMetadata } from "../../../services/siteMetadata";
import Head from "next/head";
import {ASSET_URL, DEBUG} from "../../../config";

function absolute(url) {
    if (!url) return null
    return /^https?:\/\//.test(url) ? url : ASSET_URL + url
}

// Open Graph attend « langue_TERRITOIRE » (en_US, he_IL…) : un code à deux lettres
// n'est pas une valeur valide, et les aperçus WhatsApp/Facebook retombaient alors sur
// une locale par défaut.
const OG_LOCALES = {
    fr: "fr_FR", en: "en_US", he: "he_IL", it: "it_IT", pt: "pt_PT",
    ru: "ru_RU", de: "de_DE", es: "es_ES", gr: "el_GR", ro: "ro_RO",
}

function ogLocale(lang) {
    return OG_LOCALES[String(lang || "").toLowerCase()] || null
}

/**
 * Balises de la page v2 : titre, description, aperçu de partage complet (WhatsApp,
 * Facebook, X), adresse canonique. L'ancien Meta ne posait ni og:title ni og:url,
 * d'où des aperçus WhatsApp sans titre.
 */
export default function MetaV2({context, title, description, image, video, canonical, noindex, seo}) {
    ({title, description, image} = resolveSiteMetadata(context, {title, description, image}, seo));
    const org = context.org || {}
    const siteName = org.domain || "Charithon.io"
    const pageTitle = (DEBUG ? "(Dev) " : "") + String(title || "").replace("<!-- -->", "") + " | " + siteName
    const finalImage = absolute(image) || absolute(org.logo)
    const cleanDescription = description ? String(description).replace(/[*_#>`]/g, "").slice(0, 300) : null

    return (
        <Head>
            <meta charSet="utf-8"/>
            <meta name="viewport" content="width=device-width,initial-scale=1.0"/>
            <title>{pageTitle}</title>
            {cleanDescription && <meta name="description" content={cleanDescription}/>}
            {noindex && <meta name="robots" content="noindex,nofollow"/>}
            {canonical && !noindex && <link rel="canonical" href={canonical}/>}
            {org.logo && <link rel="icon" href={absolute(org.logo)}/>}

            <meta property="og:type" content="website"/>
            <meta property="og:site_name" content={siteName}/>
            <meta property="og:title" content={title}/>
            {cleanDescription && <meta property="og:description" content={cleanDescription}/>}
            {canonical && <meta property="og:url" content={canonical}/>}
            {finalImage && <meta property="og:image" content={finalImage}/>}
            {video && <meta property="og:video" content={video}/>}
            {ogLocale(context.langValue) && <meta property="og:locale" content={ogLocale(context.langValue)}/>}

            <meta name="twitter:card" content={finalImage ? "summary_large_image" : "summary"}/>
            <meta name="twitter:title" content={title}/>
            {cleanDescription && <meta name="twitter:description" content={cleanDescription}/>}
            {finalImage && <meta name="twitter:image" content={finalImage}/>}
        </Head>
    )
}
